module.exports = __webpack_public_path__ + "img/10.24d8176c.jpg";